<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow class="mb-2">
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 15%">
                            <h1 class="custom-header-title text-center">
                                <strong> How Genie Workers Works</strong>
                            </h1>
                            <h3 class="mt-3 mb-4 text-white custom-header-subtitle text-center poppin-font">
                                Welcome to Genie Workers, where your skills take center stage, and every interaction is an<br /> opportunity to make wishes come true. Let's unveil the magic behind how Genie Workers works,<br /> empowering you to showcase
                                your craftsmanship and connect with those seeking your expertise.</h3>
                            <br>
                        </div>
                        <br /><br /> <br /> <br /><br />
    
                    </CCol>
                    <br /> <br /> <br /> <br /><br /> <br /> <br /> <br /> <br /><br />
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" style="margin:-100px auto;">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;" class="bg-services mb-5">
                <CRow>
                    <CCol sm="12">
                        <h1 class="custom-header-faq text-black poppin-font text-48px mt-5 text-center">
                            Our Services
                        </h1>
                        <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black text-center">
                            Our platform is designed to simplify the process of finding and booking reliable service <br /> providers. Explore the magic of Genie Workers and discover the services we offer:
                        </h3>
                        <CCol sm="12" class="bg-white">
                            <CRow>
                                <CCol sm="4">
                                    <div class="bg-white d-flex flex-column justify-content-between" style="min-height: 430px;">
                                        <CCol sm="12">
                                            <div class="text-left p-3">
                                                <img style="max-width:58px" src="../assets/img/house.png" />
                                                <br /> <br />
                                                <h3 class="text-black mt-2 poppin-font text-left text-bold text-servcies-title">Home Maintenance</h3>
                                                <label class="label-custom-header-subtitle poppin-font">Keep your home in top-notch condition with our home maintenance services. 
                            From minor repairs to major renovations, our trusted service providers are ready to assist.</label>
                                            </div>
                                        </CCol>
                                        <div class="text-left ml-3 mb-5">
                                            <span class="button-Explore-border">
                        <b class="ml-3 mr-3">Detail</b>  
                    </span>
                                        </div>
                                    </div>
                                </CCol>
    
                                <CCol sm="4">
                                    <div class="bg-purple-black d-flex flex-column justify-content-between" style="min-height: 430px;">
                                        <CCol sm="12">
                                            <div class="text-left p-3">
    
                                                <img style="max-width:58px" src="../assets/img/cleaning.png" />
                                                <br /> <br />
                                                <h3 class="text-white mt-2 poppin-font text-left text-bold">Cleaning Services</h3>
                                                <label class="text-white poppin-font">Experience the joy of a clean and organized space. Choose from a variety of 
                                                                                cleaning services, including regular cleaning, deep cleaning, and specialized cleaning for specific areas.</label>
                                            </div>
    
                                        </CCol>
                                        <div class="text-left ml-3 mb-5">
                                            <span class="button-Explore-border">
                        <b class="ml-3 mr-3">Detail</b>  
                    </span>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol sm="4">
                                    <div class="bg-white d-flex flex-column justify-content-between" style="min-height: 430px;">
                                        <CCol sm="12">
                                            <div class="text-left p-3">
    
                                                <img style="max-width:58px" src="../assets/img/Plumbing.png" />
                                                <br /> <br />
                                                <h3 class="text-black mt-2 poppin-font text-left text-bold text-servcies-title">Plumbing Solutions</h3>
                                                <label class="label-custom-header-subtitle poppin-font">Say goodbye to leaky faucets and plumbing issues. Our skilled plumbers are here to provide efficient and effective solutions for all your plumbing needs.</label>
                                            </div>
    
    
                                        </CCol>
                                        <div class="text-left ml-3 mb-5">
                                            <span class="button-Explore-border">
                        <b class="ml-3 mr-3">Detail</b>  
                    </span>
                                        </div>
    
                                    </div>
    
                                </CCol>
                            </CRow>
    
                        </CCol>
                        <CCol sm="12">
                            <div class="text-center mt-5">
                                <img src="../assets/img/slider.png" style="max-width:100px" />
                            </div>
                            <br /><br />
                        </CCol>
                    </CCol>
    <br /><br />    <br /><br />    <br /><br />
                </CRow>
    
            </CCol>
        </CCol>
    
        <br /><br />    <br /><br />    <br /><br />
        <CCol sm="12" class="bg-white">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <CRow class="mb-5">
                    <CCol sm="12">
                        <h1 class="header-title-genie text-black poppin-font text-48px mt-5 text-center">
                            Who Are They?
                        </h1>
                        <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black text-center">
                            Aladdin wishes, Genie Workers deliver. On the Genie Workers app, Aladdins express needs, and skilled Genie <br />
                            Workers make wishes a reality. It's the perfect match—simple, magical, and efficient.</h3>
                    </CCol>
                    <CCol sm="6">
                        <CCol sm="12" style="width: 90%;background-size: cover; margin-left: auto; margin-right: 0;">
                            <div class="bg-services text-right">
                                <CCol sm="12">
                                    <div class="text-center">
                                        <img style="max-width:100%" class="text-center mt-3" src="../assets/img/worker.png" />
                                        <br /> <br />
                                        <h3 class="poppin-font custom-who-are-they mt-2">Genie Workers</h3>
                                        <label class="custom-sub-who-are-they poppin-font">Skilled service providers</label>
                                    </div>
                                </CCol>
                            </div>
                        </CCol>
                    </CCol>
                    <CCol sm="6">
                        <CCol sm="12" style="width: 90%;background-size: cover; margin-left: 0; margin-right: auto;">
                            <div class="bg-services">
                                <CCol sm="12">
                                    <div class="text-center">
                                        <img style="max-width:100%" class="text-center mt-4" src="../assets/img/aladdin.png" />
                                        <br /> <br />
                                        <h3 class="poppin-font mt-2 custom-who-are-they mt-2">Aladdin</h3>
                                        <label class="custom-sub-who-are-they poppin-font">Users looking for services</label>
                                    </div>
                                </CCol>
                            </div>
                        </CCol>
                    </CCol>
                </CRow>
    
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12">
                <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                    <CRow>
                        <CCol sm="5">
                            <h1 class="custom-header-faq text-black poppin-font text-48px mt-5">
                                How It Works
                            </h1>
    
                        </CCol>
                        <CCol sm="7">
                            <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-right text-black mt-5">
                                Welcome to the Genie Workers app, your magical portal to <br /> connecting with users, showcasing your craftsmanship, <br />and crafting a journey of success. </h3>
                        </CCol>
                    </CRow>
                    <CRow class="mt-4">
                        <CCol sm="5">
                            <h1 class="custom-header-faq text-black poppin-font text-48px mt-5">
                                Requesting Service
                            </h1>
                            <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black mt-5">
                                Aladdins can easily describe their problem in the app or snap a picture. Our AI interprets the issue and readies the magic carpet</h3>
    
    
                            <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black mt-5">
                                <b>Our machine learning genie floats through the details, matching the task
                             with the right Genie Worker who has the perfect set of skills.</b></h3>
    
                        </CCol>
                        <CCol sm="7">
                            <CCard class="bg-grey p-5 b-20">
                                <CRow>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/1.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/2.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/3.png" /></CCol>
                                </CRow>
                            </CCard>
    
                        </CCol>
    
                        <CCol sm="7">
                            <CCard class="bg-grey p-5 b-20 mt-5">
                                <CRow>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/4.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/5.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/6.png" /></CCol>
                                </CRow>
                            </CCard>
    
                        </CCol>
    
                        <CCol sm="5">
                            <h1 class="custom-header-faq text-black poppin-font text-48px mt-5">
                                Job Application and Selection
                            </h1>
                            <h3 class="mt-1 mb-4 custom-header-subtitle-sub text-left text-black mt-5">
                                Genie Workers, equipped with a toolbelt of services, apply for tasks using credits, ensuring only serious and commited applications.</h3>
    
                            <h3 class="mt-1 mb-4 custom-header-subtitle-sub text-left text-black mt-2">
                                Aladdins receive a lamp full of Genie Workers to choose from. They pick their preferred genie, granting them the job and turning wishes into reality.</h3>
    
    
                            <h3 class="mt-1 mb-4 custom-header-subtitle-sub text-left text-black mt-2">
                                <b>Both Aladdins and Genie Workers will receive each other's contact information, </b> , enabling convenient communication. This enhancement ensures a seamless connection, fostering ongoing collaboration between the two parties.
                            </h3>
    
                        </CCol>
    
                        <CCol sm="5">
                            <h1 class="custom-header-faq text-black poppin-font text-48px mt-5">
                                Process Completed
                            </h1>
                            <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black mt-5">
                                Genie Workers ensure a quality finish before closing the task. Aladdins are invited to provide feedback, allowing them to share their satisfaction and experiences. This feedback loop contributes to the ongoing excellence of the Genie Workers community.</h3>
    
                            <h3 class="mt-3 mb-4 custom-header-subtitle-sub text-left text-black mt-5">
                                <b>Aladdins have the opportunity to rate and leave reviews for the Genie Workers.</b> This not only recognizes their excellence but also helps build a community where exceptional skills are celebrated.</h3>
    
                        </CCol>
                        <CCol sm="7">
                            <CCard class="bg-grey p-5 b-20">
                                <CRow>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/7.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/8.png" /></CCol>
                                    <CCol sm="4"> <img style="max-width:100%" src="../assets/img/9.png" /></CCol>
                                </CRow>
                            </CCard>
    
                        </CCol>
    
                    </CRow>
                </CCol>
            </CCol>
    
        </CCol>


        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrlTestimoni})` }">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center">
                            <br /><br /><br />
                            <h1 class="custom-text-aladdin text-white poppin-font text-48px">
                                What our Aladdin say about <br /> our Genie Workers.
                            </h1>
                            <br /><br /><br />
                            <CRow class="mt-4">
                                <CCol sm="6">
                                    <CCard class="card-grey p-40" style="min-height:400px">
                                        <div class="text-center">
                                            <img style="max-width:30px" src="../assets/img/leftquote.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub">“I recently used Genie Workers  <br />
                                                to find
                                                a plumber for a  <br />
                                                leaky faucet in my
                                                kitchen, and I couldn't be happier
                                                 with the experience.”</h3>
                                            <img style="max-width:100%" src="../assets/img/Line.png" class="m-2" />
                                            <CCol sm="12" style="width: 60%;margin: auto;">
                                                <CRow class="mt-2">
                                                    <CCol sm="2">
                                                        <img style="max-width:100" src="../assets/img/user1.png" />
                                                    </CCol>
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Davis Rosser <br />Plumber Services 
                                                                                        </label></CCol>
                                                </CRow>
                                            </CCol>
                                        </div>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <CCard class="card-grey p-40" style="min-height:400px">
                                        <div class="text-center">
                                            <img style="max-width:30px" src="../assets/img/leftquote.png" class="mt-5" />
                                            <br />
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 ustom-text-aladdin-sub">“From start to finish, the process was<br />
                                                seamless, and Genie Workers truly <br />
                                                 exceeded  my expectations.”</h3>
                                                 <br /><br />
                                            <img style="max-width:100%" src="../assets/img/Line.png" class="m-2" />
                                            <CCol sm="12" style="width: 60%;margin: auto;">
    
                                                <CRow class="mt-2">
                                                    <CCol sm="2">
                                                        <img style="max-width:100" src="../assets/img/user2.png" />
                                                    </CCol>
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Tiana Geidt <br />Plumber Services
                                                                                        </label></CCol>
                                                </CRow>
                                            </CCol>
                                        </div>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="12">
                                    <div class="text-center mt-5">
                                        <img src="../assets/img/slider-black.png" style="max-width:100px" />
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
    
                    </CCol>
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-left">
                    <br /><br /><br />
    
                    <div class="text-left">
                        <CCol sm="12" style="width: 90%; margin: auto;">
                            <h1 class="custom-header-faq text-black poppin-font text-48px text-left ml-3">
                                FAQs
                            </h1>
                            <CCol sm="12">
                                <div style="text-align: left;" class="{ activeclass: isActive }">
                                    <ToggleCard title="What is Genie Workers?">
                                        Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Helper simplifies the process of finding and booking reliable services.
                                    </ToggleCard>
    
                                    <ToggleCard title="How does Genie Workers work?">
                                        Genie Workers app effortlessly connects you, the 'Aladdin', with skilled 'Genie Workers' for your service needs. Just describe your issue or snap a photo, and our AI matches it with the right professional. Review profiles, select your Genie Worker, and
                                        directly coordinate the job. Our platform, focusing on convenience and security, streamlines the process from request to service completion.. To know futher, click here (open page how it works) </ToggleCard>
    
                                    <ToggleCard title="Is Genie Workers available in my area?">
                                        Genie Workers is rapidly expanding and aims to serve a wide range of urban and suburban areas. To discover if we're in your neighborhood, simply download the Genie Workers app or visit our website. Enter your location, start making a request, and choose
                                        based on your location to instantly find out if our Genie Workers are available to fulfill your service wishes nearby. Keep an eye on our updates, as we're constantly growing to bring our efficient service to even more
                                        areas! </ToggleCard>
    
                                    <ToggleCard title="What types of services are available on Genie Workers?">
                                        Genie Workers offers a vast array of services, including home maintenance, cleaning, plumbing, electrical work, wall decoration, car maintenance, and many more. Our comprehensive app is your one-stop solution, consistently updated to include new services,
                                        ensuring that all your maintenance needs are just a tap away. Dive into our app to discover the full spectrum of services we provide!</ToggleCard>
    
                                    <ToggleCard title="How do I book a service on Genie Workers?">
                                        Booking a service on Genie Workers is a breeze with our intuitive app. Simply follow the request process within the app, detailing your service needs. Once submitted, you'll receive profiles of applicants ready to help. Review their profiles, select your
                                        preferred Genie Worker, and the rest will automatically be dropped from your list. After selection, only necessary contact information is exchanged, ensuring a smooth and secure continuation of your service journey.</ToggleCard>
    
                                    <ToggleCard title="Can I communicate with the service provider directly?">
                                        Yes, direct communication with your chosen Genie Worker is facilitated by our platform. Once you've submitted your request and selected a candidate, contact details are exchanged between both parties. You have the flexibility to set the type of contact
                                        information shared, catering to your privacy preferences. To maintain privacy, consider opting for email or a Telegram link ID (without phone number) as your primary mode of contact. You can easily manage and customize
                                        these preferences on your settings page, ensuring a comfortable and secure interaction.</ToggleCard>
                                    
                                        <ToggleCard title="What are the fees for using this platform?">
                                            At Genie Workers, accessing and using our platform is completely free for our valued Aladdins—that's you, our customers! We believe in empowering you to find the perfect service provider without any upfront costs. Our model is designed to charge only the Genie Workers, our trusted service providers, a nominal fee. This occurs once you've chosen a Genie Worker for your job, facilitating the exchange of contact details. We then encourage you to directly negotiate and 
                                            finalize service details with your selected Genie Worker, ensuring transparency and satisfaction in every transaction.</ToggleCard>
    
                                </div>
                            </CCol>
    
                            <CCol sm="12">
                                <div class="text-center button-Explore-border-blue" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                    <span class="text-white">
                                        <b>Discover More</b>
                                    </span>
                                </div>
                                <br /><br /><br />
                            </CCol>
                          
    
                        </CCol>
                    </div>
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="p-1" style="background-size: cover;border-top-right-radius: 20px;border-top-left-radius: 20px; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;">
                        <div class="text-center">
                            <br />
                            <br />  <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Join the Genie Worker Community</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                        Ready to experience a new level of convenience and efficiency? Join the growing Genie <br />
                                                         Workers community and let us take care of your service needs. 
                                                        Say goodbye to the hassle <br />
                                                        of finding reliable providers – your genie is just a click away.
                                                    </label>
                                                    <br />
                            <br />  <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Register Now</span></CButton>
                            <br />
                            <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,


        };
    },
    created() {
        AOS.init();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>